import axios from "axios";
import { queryParams } from "../../../utils/queryParams";

const instance = axios.create({
  baseURL: queryParams.apiVersion + "admin/chains"
});

export const api = {
  getChains(params) {
    return instance.get("", params);
  },
  getChainInfo(params) {
    return instance.get("get_chain_info", params);
  },
  getSettings(params) {
    return instance.get("get_settings", params);
  },
  addChain(params) {
    return instance.post("", params);
  },
  updateChain(id, params) {
    return instance.put(`/${id}`, params);
  },
  removeChain(params) {
    return instance.delete(`/${params.id}`);
  }
};
